<template>
    <div class="DshList" v-show="showData">
        <!-- 表头 -->
        <div class="list-cols">
            <!-- 左 -->
            <div v-if="multiple" class="list-cols-left">
                <Checkbox
                    v-model="isSelectAll"
                    @on-change="selectAll"
                ></Checkbox>
            </div>

            <!-- 右 -->
            <div
                class="list-cols-right row"
                :style="{
                    paddingLeft: multiple ? '48px' : '5px',
                    background: useColBg ? '#E8EAEE' : 'none'
                }"
            >
                <div v-if="sequence" class="row-item" style="minWidth: 60px; textAlign: center;">
                    序号
                </div>
                <div
                    v-for="col in selfColumns"
                    :key="col._key"
                    class="row-item"
                    :style="{
                        flexBasis: (col.width || col.minWidth) + `px`,
                        textAlign: col.titleAlign,
                        flexGrow: 1
                    }"
                >
                    <Ctooltip transfer :content="col._name">
                        <span class="dsh-ellipsis">
                            {{ col._name }}
                        </span>
                    </Ctooltip>
                </div>
            </div>
        </div>

        <!-- 行 -->
        <div class="list-rows">
            <!-- 有数据 -->
            <template v-if="data.length">
                <div v-if="multiple" class="list-rows-left">
                    <CheckboxGroup v-model="selectIds" @on-change="select">
                        <Checkbox
                            v-for="row in data"
                            :key="row._id"
                            :label="row._id"
                            @click.native="clickRowCheckbox(row)"
                        >{{ "" }}</Checkbox>
                    </CheckboxGroup>
                </div>

                <div class="list-rows-right">
                    <div
                        v-for="(row, index) in data"
                        :key="row._id"
                        class="row"
                        :style="{
                            paddingLeft: multiple ? '48px' : '5px'
                        }"
                        @click="clickRow(row)"
                    >
                        <div v-if="sequence" class="row-item" style="minWidth: 60px; textAlign: center;">
                            {{ index + 1 }}
                        </div>
                        <!-- 单元格 -->
                        <div
                            v-for="(col) in selfColumns"
                            :key="col._key"
                            class="row-item"
                            :style="{
                                flexBasis: (col.width || col.minWidth) + `px`,
                                textAlign: col.columnAlign,
                                flexGrow: 1
                            }"
                        >
                            <div class="row-item-inner dsh-ellipsis">
                                <dsh-td-render
                                    v-if="col.render"
                                    class="ms-ellipsis"
                                    :row="row"
                                    :column="col"
                                    :index="index"
                                    :render="col.render"
                                ></dsh-td-render>
                                <template v-else-if="col.formatter">
                                    <div v-html="col.formatter(row, index)"></div>
                                </template>
                                <Tooltip
                                    v-else-if="row[col._key]"
                                    :transfer="true"
                                    max-width="200"
                                    :placement="index === 0 ? 'bottom-start' : 'top-start'"
                                    :content="row[col._key]"
                                    class="list-tooltip"
                                >
                                    <div class="list-tooltip-box">{{ row[col._key] }}</div>
                                </Tooltip>
                                <!-- <dsh-unit
                                    :key="col._key"
                                    :mode="mode"
                                    :canEdit="false"
                                    :formData="row"
                                    :formItem="col"
                                    :rowIndex="index"
                                    @change="change(row, col, arguments)"
                                ></dsh-unit> -->
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <!-- 无数据 -->
            <div v-else class="list-noData">
               {{noDataText}}
            </div>
        </div>
    </div>
</template>

<script>
    // import DshUnit from "../../unit/DshUnit.vue";

    export default {
        name: "DshList",
        components: {
            // DshUnit
        },
        props: {
            // mode: {
            //     type: String,
            //     default: "default",
            //     validator: function (value) {
            //         return ["default"].indexOf(value) !== -1;
            //     }
            // },
            data: {
                type: Array,
                default () {
                    return [];
                }
            },
            columns: {
                type: Array,
                default () {
                    return [];
                }
            },

            propsObj: {
                type: Object,
                default () {
                    return {
                        multiple: true,
                        useColBg: true,
                        sequence: false
                    };
                }
            },
            noDataText: {
                type: String,
                default: "暂无数据..."
            }
        },
        data () {
            return {
                showData: true,
                selections: []
                // curRow: null // 可以不声明
            };
        },
        computed: {
            selfColumns () {
                return this.columns;
            },
            selectIds: {
                get () {
                    return this.selections.map(item => item._id);
                },
                set (val) {
                    this.selections = this.data.filter(item => val.includes(item._id));
                }
            },
            isSelectAll: {
                get () {
                    return this.data.length > 0 && this.selectIds.length === this.data.length;
                },
                set (bool) {
                    this.selections = bool ? this.data : [];
                }
            },

            multiple () {
                return this.propsObj.multiple !== false;
            },
            useColBg () {
                return this.propsObj.useColBg !== false;
            },
            sequence () {
                return this.propsObj.sequence && this.propsObj.sequence !== false;
            }
        },
        created () {},
        methods: {
            /* --- 仅供外部调用 ----- */
            pushSelectIds (ids) {
                this.selectIds = this.selectIds.concat(ids);
                this.changeSelect();
            },

            // 点击某行
            clickRow (row) {
                this.$emit("clickRow", row);
            },
            // 点击某行的选择框
            clickRowCheckbox (row) {
                this.curRow = row;
                this.curRow.bool = !this.selectIds.includes(row._id);
            },
            // 切换全选
            selectAll (bool) {
                this.$emit("selectAll", this.selectIds, this.selections, bool);
                this.changeSelect();
            },
            // 切换选择
            select (selectIds) {
                this.$emit("select", this.selectIds, this.selections, this.curRow, this.curRow.bool);
                this.changeSelect();
            },

            // 改变选择项
            changeSelect () {
                this.$emit("selectChange", this.selectIds, this.selections);
            },
            change (...params) {
                this.$emit("change", ...params);
            }
        },
        watch: {
            data () {
                this.showData = false;
                this.$nextTick(() => {
                    this.showData = true;
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshList {
        .list {
            &-cols,
            &-rows {
                position: relative;
                &-left {
                    width: 48px;
                    text-align: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                    label {
                        display: inline-block;
                        height: 36px;
                        padding: 9px 5px;
                        margin: 0px;
                        line-height: 18px;
                    }
                }
                &-right {}

                .row {
                    width: 100%;
                    height: 36px;
                    padding: 9px 5px;
                    line-height: 18px;
                    display: flex;
                    justify-content: space-between;
                    &-item {
                        min-width: 120px;
                        height: 100%;
                        padding: 0 5px;
                        font-size: 14px;
                        align-items: center;
                    }
                }
            }

            &-cols {
                &-left {}
                &-right {}

                .row {
                    // background-color: #E8EAEE;
                    font-weight: 700;
                    &-item {}
                }
            }

            &-rows {
                &-left {
                    label {
                        height: 44px;
                        line-height: 26px;
                    }
                }
                &-right {}

                .row {
                    height: 45px;
                    line-height: 26px;
                    border-bottom: 1px solid #ddd;
                    cursor: pointer;
                    &-item {
                        &-inner {}
                    }
                }
            }

            &-noData {
                text-align: center;
            }
        }
    }
</style>
<style lang="less">
    .DshList {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/list/DshBox/DshList.vue